import { render, staticRenderFns } from "./SelectTipoColeta.vue?vue&type=template&id=1fb5f14d&scoped=true&"
import script from "./SelectTipoColeta.vue?vue&type=script&lang=ts&"
export * from "./SelectTipoColeta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5f14d",
  null
  
)

export default component.exports